import { Content } from "./content";

export class BatchInfo {
    constructor(
        public readonly content: Content,
        public readonly ids: string[]
    ) {
    }

    get model(): any {
        const { content, ids } = this;
        return {
            content: content.model,
            ids
        };
    }
}
